/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { OverlayTrigger, Popover } from "react-bootstrap";
import Modal from "react-modal";
import "./Header.css";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "react-bootstrap";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import InputForm, { AutoCompleteValue } from "../../Components/InputForm/InputForm";
import { clearUserData, setUserData } from "../../Redux/Actions";
import { AllRoutes } from "../../Routes/router";
import ComponentLoader from "../../Helpers/Loader/ComponentLoader";
import { getCurrentUserRolesDropdown, changePassword, logoutUrl } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { getDefaultDashboard } from "../../Helpers/Common";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { AlertType } from "../../Helpers/Enums/AlertType";
import { GenericResponseModel } from "../../Models/GenericResponseModel";
import { MemberRegistrationUserType } from "../../Helpers/Enums/MemberRegistrationUserType";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import UserDetailsModal from "./tmp/UserDetailsModal";

Modal.setAppElement("#root"); // Use the selector for your root element

const Header = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const context = getContext();
  const dispatch = useDispatch();
  const { showLoader, hideLoader } = useContext(LoaderContext);

  let userBranding = "mk";
  const [title, setTitle] = useState<string>("Credit Society");
  const [Username, setUsername] = useState<string>(`${context?.FirstName || ""} ${context?.MiddleName || ""} ${context?.LastName || ""}`);
  const [rolesArray, setRolesArray] = useState<any>([]);
  const [roleValue, setRoleValue] = useState<any>(null);
  const [shouldShowOnOpenPages] = useState<boolean>(window.location.pathname !== AllRoutes.MemberRegistrationForm.link);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [showUserDetailsModal, setShowUserDetailsModal] = useState(false);

  const [changeTextFieldPassword, setchangeTextFieldPassword] = useState(false);
  const [changeTextFieldConfirmPassword, setchangeTextFieldConfirmPassword] = useState(false);
  const [changeTextFieldOldPassword, setchangeTextFieldOldPassword] = useState(false);

  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitClicked, setIsSubmitClicked] = useState<boolean>(false);
  const [showFields, setShowFields] = useState<boolean>(false);
  const [validationList, setValidationList] = useState<Array<any>>([
    { isSuccess: false, message: "1 Capital letter" },
    { isSuccess: false, message: "1 Numeric character" },
    { isSuccess: false, message: "1 Special character" },
    { isSuccess: false, message: "Minimum 8 character" },
    { isSuccess: false, message: "Maximum 16 character" },
  ]);

  const [formErrors, setFormErrors] = useState({});
  let formErrorObj = {};
  // const initialAlert = {
  //   message: "",
  //   type: AlertType.error,
  // };
  // const [alertObj, setAlertObj] = useState<{
  //   message: any;
  //   type: AlertType;
  // }>(initialAlert);

  useEffect(() => {
    //CurrentuserRoleDropdownApiCall();
    if (shouldShowOnOpenPages && context?.Roles) {
      // const RoleIdArr = context.RoleIds.split(",");
      // const RoleNamesArr = context.RoleNames.split(",");
      const RolesArr = context.Roles;
      let newRoleArr = [];
      for (let index = 0; index < RolesArr.length; index++) {
        const role = RolesArr?.[index];
        newRoleArr.push({
          value: role.RoleId,
          label: role.RoleName,
        });
      }
      newRoleArr = newRoleArr.sort((a, b) => a.label.localeCompare(b.label));
      setRolesArray(newRoleArr);
      if (!context.CurrentRoleId) {
        let currentRole = newRoleArr?.[0];
        if (currentRole) {
          setRoleValue(currentRole);
          let newUserData = { ...context };
          newUserData.CurrentRoleId = parseInt(currentRole?.value) as RoleEnum;
          newUserData.loggedInAs = {
            label: currentRole?.label,
            value: currentRole?.value,
          };
          dispatch(setUserData(newUserData));
          if (location.search) {
            const params = new URLSearchParams(location.search);
            const hasMemberId = params.has("memberid");
            const hasSuretyId = params.has("suretyid");

            if (hasMemberId || hasSuretyId) {
              let memberRole = newRoleArr.find((nra) => (nra?.value as RoleEnum) === RoleEnum.Member);
              if (memberRole) {
                setRoleValue(memberRole);
                newUserData = { ...context };
                newUserData.CurrentRoleId = parseInt(memberRole?.value) as RoleEnum;
                newUserData.loggedInAs = {
                  label: memberRole?.label,
                  value: memberRole?.value,
                };
              }
            }
            dispatch(setUserData(newUserData));

            if (hasMemberId) {
              navigate(AllRoutes.MemberVerificationView.link + "?memberid=" + params.get("memberid"));
              return;
            } else if (hasSuretyId) {
              navigate(AllRoutes.SuretyApproval.link + "?suretyid=" + params.get("suretyid"));
              return;
            } else if (params.has("docid")) {
              navigate(AllRoutes.DownloadDoc.link + "?docid=" + params.get("docid"));
              return;
            }
          }
          let page = getDefaultDashboard(newUserData.CurrentRoleId);
          navigate(page, { state: 0 });
        }
      } else {
        let role = newRoleArr.find((nr) => nr.value === context.CurrentRoleId);
        if (role) {
          setRoleValue(role);
        }
      }
    }
  }, []);

  const EyeIcon = ({ visible, toggleVisibility }) => {
    const iconClass = visible ? "fa fa-eye icon" : "fa fa-eye-slash icon";

    return (
      <span onClick={toggleVisibility} style={{ cursor: "pointer" }}>
        <i className={iconClass}></i>
      </span>
    );
  };

  const openModal = () => {
    setModalIsOpen(true);
    clearFunction();
  };

  const closeModal = () => {
    setModalIsOpen(false);
    clearFunction();
  };

  const visiblePassword = (field) => {
    if (field === "password") {
      setchangeTextFieldPassword(!changeTextFieldPassword);
    } else if (field === "confirm") {
      setchangeTextFieldConfirmPassword(!changeTextFieldConfirmPassword);
    } else {
      setchangeTextFieldOldPassword(!changeTextFieldOldPassword);
    }
  };

  const clearFunction = () => {
    setOldPassword("");
    setPassword("");
    setConfirmPassword("");
    setIsSubmitClicked(false);
    setchangeTextFieldPassword(false);
    setchangeTextFieldConfirmPassword(false);
    setchangeTextFieldOldPassword(false);
  };

  const onSubmitValidation = () => {
    setFormErrors({});
    formErrorObj = {};
    let message = "";

    if (!/.*[A-Z].*/.test(password)) {
      message += "1 Capital letter required, ";
    }

    if (!/.*\d.*/.test(password)) {
      message += "1 Numeric character required, ";
    }

    if (!/.*[!@#$%^&*()\-_=+{}[\]:;"'<>,.?].*/.test(password)) {
      message += "1 Special character required, ";
    }

    if (password.length < 8) {
      message += "Minimum 8 characters required, ";
    }

    if (password.length > 16) {
      message += "Maximum 16 characters required, ";
    }

    if (message != "") {
      notify(1, message);
      setFormErrors((formErrorObj["Error"] = "Password should have atlest"));
    } else {
      setFormErrors({});
    }
  };

  const updatePassword = async () => {
    setIsSubmitClicked(true);
    if ((!oldPassword && !password) || !confirmPassword || password !== confirmPassword) {
      return;
    }

    await onSubmitValidation();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });

    if (isEmpty === true) {
      showLoader();
      try {
        let resp = await APICall(changePassword, {
          LoginId: context?.LoginId,
          OldPassword: oldPassword,
          NewPassword: password,
          ConfirmPassword: confirmPassword,
        });

        if (resp.Status === ApiStatus.OK) {
          if (resp.Data) {
            let loginResp = resp.Data as GenericResponseModel;
            if (loginResp.Status) {
              setShowFields(false);
              notify(0, "Password reset successful");
              closeModal();
            } else {
              notify(1, loginResp?.Message);
            }
          }
        } else {
          notify(1, resp?.Message);
        }
      } catch (err) {
      } finally {
        hideLoader();
      }
    }
  };

  enum TextInputTarget {
    OldPassword,
    Password,
    ConfirmPassword,
  }

  const checkValidation = (value: string, target: TextInputTarget) => {
    switch (target) {
      case TextInputTarget.Password:
        const newValidationList = [];
        newValidationList.push({
          isSuccess: /.*[A-Z].*/.test(value),
          message: "1 Capital letter",
        });
        newValidationList.push({
          isSuccess: /.*\d.*/.test(value),
          message: "1 Numeric character",
        });
        newValidationList.push({
          isSuccess: /.*[!@#$%^&*()\-_=+{}[\]:;"'<>,.?].*/.test(value),
          message: "1 Special character",
        });
        newValidationList.push({
          isSuccess: value.length > 8,
          message: "Minimum 8 character",
        });
        newValidationList.push({
          isSuccess: value.length < 16,
          message: "Maximum 16 character",
        });

        setValidationList(newValidationList);
        break;
      case TextInputTarget.ConfirmPassword:
        break;
    }
  };

  const onTextChanged = (event, target: TextInputTarget) => {
    const value = event.target.value;
    switch (target) {
      case TextInputTarget.Password:
        setPassword(value);
        checkValidation(value, target);
        break;
      case TextInputTarget.ConfirmPassword:
        setConfirmPassword(value);
        break;
      case TextInputTarget.OldPassword:
        setOldPassword(value);
        break;
    }
  };

  const ValidationSpan = (props) => {
    const { isSuccess, message } = props;
    return (
      <span className={"px-3 " + (isSuccess ? "text-success" : "text-danger")}>
        <i className={`fa-solid ${isSuccess ? "fa-check" : "fa-xmark"} px-2`}></i>
        {message}
      </span>
    );
  };

  const Logout = async () => {
    showLoader();
    try {
      const resp = await APICall(logoutUrl, {
        UserId: context.Id,
      });

      if (resp.Status === ApiStatus.OK && resp.Data?.id > 0) {
        dispatch(clearUserData(null));
        if (context?.UserType === MemberRegistrationUserType.Staff) {
          navigate(AllRoutes.login.link);
        } else {
          window.location.href = "https://login.microsoftonline.com/common/oauth2/logout";
        }
      } else {
        notify(ToastType.Error, "There is issue while logging out, please contact administrator before login again.");
      }
    } catch (err) {
      notify(ToastType.Error, "There is issue while logging out, please contact administrator before login again.");
    } finally {
      hideLoader();
    }
  };

  enum ButtonClickTarget {
    ResetPassword,
  }

  const onButtonClick = (target: ButtonClickTarget) => {
    switch (target) {
      case ButtonClickTarget.ResetPassword:
        updatePassword();
        break;
    }
  };

  const CurrentuserRoleDropdownApiCall = async () => {
    const resp = await APICall(getCurrentUserRolesDropdown, {
      Id: 1,
    });
    if (resp?.Data?.Data?.length > 0) {
      const roles = resp?.Data?.Data.map((d) => ({
        value: d?.RoleId,
        label: d?.RoleName,
      })).sort((a, b) => a.label.localeCompare(b.label));
      setRolesArray(roles);
      setRoleValue(roles?.[0]);
    }
  };
  const popover = (
    <Popover>
      <Popover.Header
        onClick={(e) => {
          if (e.altKey) {
            setShowUserDetailsModal(true);
          }
        }}
      >
        {Username?.trim() || ""}
      </Popover.Header>
      {context?.UserType === MemberRegistrationUserType.Staff && (
        <Popover.Body>
          <a
            className="changePassword"
            onClick={() => {
              openModal();
            }}
          >
            Change Password
          </a>
        </Popover.Body>
      )}
      <Popover.Body>
        <a
          className="changePassword"
          onClick={() => {
            Logout();
          }}
          // rel="noopener noreferrer"
          // href={"http://localhost:3000/login"}
        >
          Logout
        </a>
      </Popover.Body>
    </Popover>
  );

  const onRoleChange = (event) => {
    setRoleValue(event);
    let newUserData = { ...context };
    newUserData.loggedInAs = {
      label: event?.label,
      value: event?.value,
    };
    newUserData.CurrentRoleId = parseInt(event?.value) as RoleEnum;
    dispatch(setUserData(newUserData));
    let page = getDefaultDashboard(event?.value);
    navigate(page);
    window.location.reload();
  };

  return (
    <header id="header">
      {userBranding != "mv" && (
        <div
          className="headerbar"
          style={{
            backgroundImage: `url("../images/header_bg.jpg")`,
            backgroundSize: "100% 100%",
          }}
        >
          <div
            className="headerbar-left left-logo"
            // style={{ marginRight: "50px" }}
          >
            <ul className="header-nav header-nav-options">
              <li className="sandwich-menu">
                <a
                  className="btn btn-icon-toggle btn-default menubar-toggle"
                  data-toggle="menubar"
                  onClick={(e) => {
                    e.preventDefault();
                    props.menuOpenFunc();
                  }}
                >
                  <i className="fa fa-bars"></i>{" "}
                </a>
              </li>
              <li className="header-nav-brand">
                <div className="brand-holder">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      let page = getDefaultDashboard(context?.CurrentRoleId);
                      navigate(page);
                    }}
                  >
                    {userBranding === "mv" && <img src="../../../images/Tata_Motors_Logo.jpg" alt="" className="logo" />}
                    {userBranding != "mv" && <img src="../../../images/getsitelogo.png" alt="" className="logo" />}
                  </a>
                  {userBranding === "mv" && (
                    <a
                      style={{
                        marginTop: "8px",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        let page = getDefaultDashboard(context?.CurrentRoleId);
                        navigate(page);
                      }}
                      className="page-header ml-2"
                    >
                      <i className="fas fa-file-alt"></i> {title}
                    </a>
                  )}
                  {userBranding !== "mv" && (
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        let page = getDefaultDashboard(context?.CurrentRoleId);
                        navigate(page);
                      }}
                      className="page-header ml-2"
                    >
                      | {title}
                    </a>
                  )}
                </div>
              </li>
            </ul>
          </div>
          <div className="float-right no-padding nav-right" style={{ paddingRight: "5px" }}>
            {shouldShowOnOpenPages && (
              <ul className="right-head float-right">
                <li style={{ width: "15rem" }} className="Role_select">
                  <div className=" dropdown"></div>
                  <SelectForm
                    options={rolesArray}
                    placeholder="Select"
                    isDisabled={false}
                    value={roleValue}
                    onChange={(event) => onRoleChange(event)}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </li>

                <li className="mx-3">
                  <OverlayTrigger trigger="click" placement="bottom" overlay={popover} rootClose>
                    <div className="user-profile dropdown" style={{ cursor: "pointer" }}>
                      <div data-toggle="dropdown">
                        <a className="dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i className="fa fa-user"></i> <span className="desktop">{Username}</span>
                        </a>
                      </div>
                    </div>
                  </OverlayTrigger>
                </li>
              </ul>
            )}
          </div>
        </div>
      )}
      {userBranding == "mv" && (
        <div
          className="headerbar"
          style={{
            backgroundImage: `url("../images/header2.png")`,
            backgroundSize: "100% 100%",
          }}
        >
          <div
            className="headerbar-left left-logo"
            // style={{ marginRight: "50px" }}
          >
            <ul className="header-nav header-nav-options">
              <li className="sandwich-menu">
                <a
                  className="btn btn-icon-toggle btn-default menubar-toggle"
                  data-toggle="menubar"
                  onClick={(e) => {
                    e.preventDefault();
                    props.menuOpenFunc();
                  }}
                >
                  <i className="fa fa-bars"></i>{" "}
                </a>
              </li>
              <li className="header-nav-brand">
                <div className="brand-holder">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      let page = getDefaultDashboard(context?.CurrentRoleId);
                      navigate(page);
                    }}
                  >
                    {userBranding === "mv" && <img src="../../../images/getsitelogo.png" alt="" className="logo" />}
                  </a>
                  {userBranding === "mv" && (
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        let page = getDefaultDashboard(context?.CurrentRoleId);
                        navigate(page);
                      }}
                      className="page-header ml-2"
                    >
                      | {title}
                    </a>
                  )}
                </div>
              </li>
            </ul>
          </div>
          <div className="float-right no-padding nav-right" style={{ paddingRight: "5px" }}>
            {shouldShowOnOpenPages && (
              <ul className="right-head float-right">
                <li style={{ width: "120px" }} className="Role_select">
                  <div className=" dropdown">
                    <SelectForm
                      options={rolesArray}
                      placeholder="Select"
                      isDisabled={false}
                      value={""}
                      onChange={(event) => onRoleChange(event)}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                  </div>
                </li>
                <li>
                  <OverlayTrigger trigger="click" placement="bottom" overlay={popover} rootClose>
                    <div className="user-profile dropdown" style={{ cursor: "pointer" }}>
                      <div data-toggle="dropdown">
                        <a className="dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i className="fa fa-user"></i> <span className="desktop">{Username}</span>
                        </a>
                      </div>
                    </div>
                  </OverlayTrigger>
                </li>
              </ul>
            )}
          </div>
        </div>
      )}

      <div className="ModalSize">
        <Modal
          ariaHideApp={false}
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Chnage Password"
          style={{
            content: {
              width: "50%", // Adjust this value as needed
              height: "35em", // Adjust this value as needed
              margin: "auto", // Center the modal horizontally
              backgroundColor: "white",
              padding: 0,
            },
          }}
        >
          <div className="modal-header">
            <h3>Change Password</h3>
          </div>
          <div className="modal-body">
            <div style={{ marginBottom: "15px" }}>
              <ComponentLoader show={false}>
                <div className="form_grid">
                  <div className="form-group input-container">
                    <label>Old Password</label>
                    <sup>*</sup>
                    <div className="eyeOnInput">
                      <InputForm
                        type={changeTextFieldOldPassword ? "text" : "password"}
                        placeholder={"Old Password"}
                        value={oldPassword}
                        className="input-field"
                        onChange={(event: React.ChangeEvent) => onTextChanged(event, TextInputTarget.OldPassword)}
                        textArea={false}
                      />
                      <EyeIcon visible={changeTextFieldOldPassword} toggleVisibility={() => visiblePassword("")} />
                    </div>
                    {isSubmitClicked && !oldPassword && (
                      <div>
                        {" "}
                        {/* className="pt-3" */}
                        <ValidationSpan isSuccess={false} message="This field is required" />
                      </div>
                    )}
                  </div>
                  <div className="form-group input-container">
                    <label>New Password</label>
                    <sup>*</sup>
                    <div className="eyeOnInput">
                      {/* <InputGroup> */}
                      <InputForm
                        type={changeTextFieldPassword ? "text" : "password"}
                        placeholder={"New Password"}
                        value={password}
                        className="input-field"
                        onChange={(event: React.ChangeEvent) => onTextChanged(event, TextInputTarget.Password)}
                        textArea={false}
                      />
                      <EyeIcon visible={changeTextFieldPassword} toggleVisibility={() => visiblePassword("password")} />
                    </div>

                    {isSubmitClicked && !password && (
                      <div>
                        {" "}
                        {/* className="pt-3" */}
                        <ValidationSpan isSuccess={false} message="This field is required" />
                      </div>
                    )}
                  </div>
                  {password && (
                    <div className="pb-3">
                      <ul>
                        <span>Password must contain : </span>
                        {validationList.map((v) => {
                          return <ValidationSpan {...v} />;
                        })}
                      </ul>
                    </div>
                  )}
                  <div className="form-group">
                    <div className="input-container">
                      <label>Confirm Password</label>
                      <sup>*</sup>
                      <div className="eyeOnInput">
                        <InputForm
                          type={changeTextFieldConfirmPassword ? "text" : "password"}
                          placeholder={"Confirm Password"}
                          value={confirmPassword}
                          className="input-field"
                          onChange={(event: React.ChangeEvent) => onTextChanged(event, TextInputTarget.ConfirmPassword)}
                          textArea={false}
                        />
                        <EyeIcon visible={changeTextFieldConfirmPassword} toggleVisibility={() => visiblePassword("confirm")} />
                      </div>
                    </div>

                    {isSubmitClicked && !confirmPassword && (
                      <div>
                        {" "}
                        {/* className="pt-3" */}
                        <ValidationSpan isSuccess={false} message="This field is required" />
                      </div>
                    )}
                    {password && confirmPassword && password !== confirmPassword && (
                      <div>
                        {" "}
                        {/* className="pt-3" */}
                        <ValidationSpan isSuccess={password === confirmPassword} message="Password doesn't match" />
                      </div>
                    )}
                  </div>
                </div>

                {/* {alertObj.message && (
                  <div className="p-3">
                    <Alert
                      variant={
                        alertObj.type === AlertType.error ? "danger" : "success"
                      }
                      onClose={() =>
                        setAlertObj({ ...alertObj, ...initialAlert })
                      }
                      dismissible={alertObj.type !== AlertType.error}
                    >
                      <p>{alertObj.message}</p>
                    </Alert>
                  </div>
                )} */}
              </ComponentLoader>
            </div>
          </div>
          <div className="modal-footer">
            <div>
              <button
                className="btn btn-signUp"
                style={{
                  padding: "5px 20px",
                  fontSize: "14px",
                  backgroundColor: "#6c757d",
                  border: "1px solid #6c757d",
                }}
                onClick={closeModal}
              >
                Cancel
              </button>
            </div>
            <div>
              <button className="btn btn-signUp" style={{ padding: "5px 20px", fontSize: "14px" }} onClick={() => onButtonClick(ButtonClickTarget.ResetPassword)}>
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      </div>
      {showUserDetailsModal && <UserDetailsModal showUserDetailsModal={showUserDetailsModal} setShowUserDetailsModal={setShowUserDetailsModal} />}
    </header>
  );
};

export default Header;
